import { mapGetters, mapActions } from 'vuex'
import SpinnersGame from '@/store/models/games/spinners/SpinnersGame'
import SpinnersListing from './components/SpinnersListing'
import { COLOR_HEXCODES, GAME_STATUS } from './utils'

export default {
  metaInfo: {
    title: 'Spinner Battles',
  },
  components: { SpinnersListing },
  data: () => ({
    loading: {
      create: false,
    },
    inputs: {
      create: {
        amount: null,
        slots: 2,
        color: 'red',
      },
    },
    handlers: {},
  }),
  computed: {
    ...mapGetters({
      user: 'user/session',
      conga: 'conga/conga',
      settings: 'settings/settings',
      activeGames: 'games/spinners/activeGames',
    }),
    gameConfig() {
      return this.conga.games?.spinners ?? {}
    },
    colors() {
      return COLOR_HEXCODES
    },
    pickableColors() {
      const { colors, inputs: { create: { slots } } } = this

      return Object
        .entries(colors)
        .slice(0, slots)
        .reduce((acc, [k, v]) => {
          acc[k] = v
          return acc
        }, {})
    },
    sortedOwnGames() {
      if (!this.user) return []

      return SpinnersGame.query()
        .where(game => !!game.players[this.user.steamid])
        .orderBy('rolledAt', 'desc')
        .orderBy('amount', 'desc')
        .get()
    },
    sortedGames() {
      const { user } = this

      if (!user) {
        return SpinnersGame.query()
          .orderBy('rolledAt', 'desc')
          .orderBy('amount', 'desc')
          .get()
      }

      return SpinnersGame.query()
        .where(game => !game.players[this.user.steamid])
        .orderBy('rolledAt', 'desc')
        .orderBy('amount', 'desc')
        .get()
    },
  },
  methods: {
    ...mapActions({
      subscribe: 'subscribe',
      unsubscribe: 'unsubscribe',
      joinGame: 'games/spinners/join',
      requestBot: 'games/spinners/requestBot',
      expireGame: 'games/spinners/expire',
      createGame: 'games/spinners/create',
    }),
    async onCreateGame() {
      const form = this.inputs.create
      if (!form.amount) return

      this.loading.create = true

      try {
        await this.createGame(form)
      } catch (error) {
        this.$toast.error(error.message)
      } finally {
        this.loading.create = false
      }
    },
    async onJoinGame(id, color) {
      if (!id || !color) return

      const game = SpinnersGame.find(id)

      if (this.user?.balance < game.amount) return

      try {
        await this.joinGame({ id, color })
      } catch (error) {
        this.$toast.error(error.message)
      }
    },
    async onRequestBot(id, color) {
      if (!id || !color) return

      const game = SpinnersGame.find(id)

      try {
        await this.requestBot({ id, color })
      } catch (error) {
        this.$toast.error(error.message)
      }
    },
    async onExpireGame(id) {
      if (!id) return

      try {
        await this.expireGame(id)
      } catch (error) {
        this.$toast.error(error.message)
      }
    },
    onRemoveFinished() {
      SpinnersGame.delete(game => game.status === GAME_STATUS.complete)
    },
  },
  async beforeDestroy() {
    Object.values(this.handlers).forEach(i => clearInterval(i))
  },
}
